export const AVATAR_DEFAULT_SRC =
  "https://imgcdn.kuick.com/kuickfortakeaway/customer-support/Default_pfp.svg";

  export const NO_DATA_FOUND_IMAGE = "https://imgcdn.kuick.com/kuickfortakeaway/customer-support/nodata.png"

  export const COUNTRIES_JSON_URL =
  "/countries.json";  
